import { render, staticRenderFns } from "./Section4th.vue?vue&type=template&id=1b3b004c&scoped=true&"
import script from "./Section4th.vue?vue&type=script&lang=js&"
export * from "./Section4th.vue?vue&type=script&lang=js&"
import style0 from "./Section4th.vue?vue&type=style&index=0&id=1b3b004c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b004c",
  null
  
)

export default component.exports